module.exports = __webpack_public_path__ + "static/media/liftoff-with-oreo-on-zerog-fr.bb615b19.png";